// extracted by mini-css-extract-plugin
export default {"title":"ModuleManagement_title__DVr08"};